import { useRef, useState } from "react";
import { motion } from "framer-motion";

// Magnetic wrapper: element gently follows the cursor when hovered nearby.
export function Magnetic({ children, strength = 0.35, className = "" }) {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const handleMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const relX = e.clientX - (rect.left + rect.width / 2);
    const relY = e.clientY - (rect.top + rect.height / 2);
    setPos({ x: relX * strength, y: relY * strength });
  };

  return (
    <motion.div
      ref={ref}
      className={className}
      onMouseMove={handleMove}
      onMouseLeave={() => setPos({ x: 0, y: 0 })}
      animate={{ x: pos.x, y: pos.y }}
      transition={{ type: "spring", stiffness: 200, damping: 15, mass: 0.5 }}
    >
      {children}
    </motion.div>
  );
}

// Magnetic pill button (link or button).
export function MagneticButton({ children, as = "a", className = "", ...props }) {
  const Comp = motion[as] || motion.a;
  return (
    <Magnetic strength={0.4} className="inline-block">
      <Comp
        {...props}
        className={
          "group relative inline-flex items-center gap-3 rounded-full border border-gold/60 px-8 py-4 text-xs uppercase tracking-[0.25em] text-gold transition-colors duration-500 hover:text-navy-900 " +
          className
        }
      >
        <span className="absolute inset-0 -z-0 rounded-full bg-gold scale-0 origin-center transition-transform duration-500 ease-out group-hover:scale-100" />
        <span className="relative z-10 flex items-center gap-3">{children}</span>
      </Comp>
    </Magnetic>
  );
}
